import { type ReactNode, useEffect } from "react";
import { isAndroidMiniapp, safeCallEitaaWebApp } from "@/utils/utilities";
import { useSettingStore } from "@/store/setting-store";

const enableFullscreen = (isFullscreen: boolean) => {
  if (!isAndroidMiniapp()) return;

  try {
    if (isFullscreen === true) {
      const WebApp = window.Eitaa!.WebApp!;
      WebApp.requestFullscreen?.();
    }
  } catch {
    console.warn("⚠️ Fullscreen not supported on this device.");
  }
};

export const MiniappProvider = ({ children }: { children: ReactNode }) => {
  const { isFullscreen } = useSettingStore();

  useEffect(() => {
    if (!isAndroidMiniapp()) return;

    const WebApp = window.Eitaa.WebApp;

    try {
      safeCallEitaaWebApp(() => WebApp.ready());
      safeCallEitaaWebApp(() => WebApp.expand?.());
      safeCallEitaaWebApp(() => WebApp.enableClosingConfirmation());
      safeCallEitaaWebApp(() => WebApp.disableVerticalSwipes());
    } catch (e) {
      console.warn("⚠️ Init failed:", e);
    }

    enableFullscreen(isFullscreen);

    const handleVisibilityChange = () => {
      if (!document.hidden) enableFullscreen(isFullscreen);
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isFullscreen]);

  return <>{children}</>;
};
